import React from "react"
import Header from "../../components/Sidebar/Header"
import { H2POPupMainText } from "../../theme/Theme";
import ThemeColor from "../../theme/ThemeColor";

const Dashboard = () =>{
    const userDetails =  JSON.parse(localStorage.getItem("userdetails"));

    return(
        <>
            <div style={{display:'flex', flexDirection:'column', marginTop: '2px', flexGrow: 1}}>
                <Header />  
                <H2POPupMainText sx={{m:1, color: '#004977'}}>Welcome {`${userDetails?.AdminName}`}</H2POPupMainText>
            </div>
        </>
    )
}

export default Dashboard